import styled from "@emotion/styled";

export const ActionColumn = styled.td`
  text-align: right;
`;

export const ButtonWrapper = styled.div`
  display: inline-flex;
  gap: 10px;
`;